import { BROADCASTCHANNEL_TYPES, SetupBroadcastChannel } from '@/Data/Functions/BroadcastChannels';
import { convertToUTC } from '@/Data/Functions/dateLocalisation';
import { DateTime } from 'luxon';

const AUTHITEMNAME = 'mtjwt',
    SUPERCOOKIE = 'superToken';
const USEROBJECTNAME = 'authUserInfo';

function UserModel(
    name = 'LOGIN',
    username = 'your@email.com',
    groupId = 0,
    securityLevelName = 'NOT LOGGED IN',
    cashierNumber = 0) {
    this.name = name;
    this.username = username;
    this.groupId = groupId;
    this.securityLevelName = securityLevelName;
    this.cashierNumber = cashierNumber;
    this.shortName = name.split(' ')[0];
    this.userInitial = (name.length > 0 ? name.toUpperCase().charAt(0) : 'X');
}

const auth = {
    status() {
        const authObject = auth.get();

        return (typeof authObject === 'undefined' ||
            authObject === null ||
            authObject === '')
            ? false
            : true;
    },
    superStatus() {
        const superObject = auth.getSuper();

        return (typeof superObject === 'undefined' ||
            superObject === null ||
            superObject === '')
            ? false
            : true;
    },
    get() {
        const cookieValueToReturn = GetTokenCookie(AUTHITEMNAME);

        return cookieValueToReturn;
    },
    getSuper() {
        let cookieValueToReturn = GetTokenCookie(SUPERCOOKIE);
        const now = convertToUTC(DateTime.now());
        const cookieDate = cookieValueToReturn.split(`${SUPERCOOKIE}-`)[1];

        if (DateTime.fromHTTP(cookieDate, { zone: 'utc' }) <= now) {
            auth.removeSuper();
            cookieValueToReturn = GetTokenCookie(SUPERCOOKIE);
        }

        return cookieValueToReturn;
    },
    userinfo() {
        let userCookieData = GetUserObjectCookie(),
            data = new UserModel();
        if (userCookieData != '' && userCookieData.length > 0) {
            data = JSON.parse(userCookieData);
        }

        return {
            status: (typeof data == 'object'),
            userinfo: data
        };
    },
    set(data) {
        if (typeof data.token != 'string') {
            throw `Value must be a string however value was passed in as a '${typeof data.token}'!`;
        }

        SetCookieByName(AUTHITEMNAME, 7, data.token);

        // Refresh token doesn't contain user data so don't try to update it
        if (data.name) {
            const userSaveData = new UserModel(data.name, data.username, data.groupId, data.securityLevelName, data.cashierNumber);

            SetCookieByName(USEROBJECTNAME, 7, JSON.stringify(userSaveData));
        }

        SetupUserStateBroadcastChannel();

        return true;
    },
    setSuper() {
        const expDate = convertToUTC(DateTime.now().plus({ days: 1 }));

        return SetCookieByName(SUPERCOOKIE, 1, `${SUPERCOOKIE}-${expDate.toHTTP()}`);
    },
    remove() {
        const toReturn = ((document.cookie = `${AUTHITEMNAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
            && (document.cookie = `${USEROBJECTNAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`)
            && (document.cookie = `${SUPERCOOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`));

        SetupUserStateBroadcastChannel();

        return toReturn;
    },
    removeSuper() {
        return (document.cookie = `${SUPERCOOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`);
    }
};

export default auth;

function GetTokenCookie(cookieName) {
    const name = `${cookieName}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    let cookieValueToReturn = '';
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            cookieValueToReturn = c.substring(name.length, c.length);
        }
    }

    return cookieValueToReturn;
}

function SetCookieByName(cookieName, cookieExpiryInDays, cookieData) {
    const expiryDate = convertToUTC(DateTime.now().plus({ days: cookieExpiryInDays }));

    document.cookie = `${cookieName}=${cookieData}; expires=${expiryDate.toHTTP()}`;

    return true;
}

function SetupUserStateBroadcastChannel() {
    /* Create broadcast channel */
    const userBroadcast = SetupBroadcastChannel(BROADCASTCHANNEL_TYPES.CLOUD_MT_USER_CHANGED);

    /* Notify interested parties of change */
    userBroadcast.postMessage(true);
}

function GetUserObjectCookie() {
    const name = `${USEROBJECTNAME}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    let cookieValueToReturn = '';
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            cookieValueToReturn = c.substring(name.length, c.length);
        }
    }

    return cookieValueToReturn;
}
